<script>
import _ from 'lodash'
import { mapState } from 'vuex'
import { ACCOUNT_FILE_DETAILS, ACCOUNT_FILE_GET } from '../../store/actions/accounts'

export default {

  data: function () {
    return {
      intervalId: null,
      pendingRequests: []
    }
  },

  render: () => null,

  computed: {
    ...mapState({
      pendingDownloads: state => state.fileDownloads.pendingDownloads
    })
  },

  mounted () {
    this.intervalId = window.setInterval(() => {
      let vm = this

      _.each(this.pendingDownloads, function (file) {
        const data = {
          account_id: file.accountId,
          file_id: file.id
        }

        if (!vm.pendingRequests.includes(file.id)) {
          vm.pendingRequests.push(file.id)
          vm.$store.dispatch(ACCOUNT_FILE_DETAILS, data).then(response => {
            if (response.data.status === 'accessible') {
              const data = {
                account_id: file.accountId,
                file_name: response.data.file.original_file_name,
                file_id: file.id
              }
              vm.$store.dispatch(ACCOUNT_FILE_GET, data).then(response => {
                const url = response.data.url
                const link = document.createElement('a')
                link.href = url
                document.body.appendChild(link)
                link.click()
                link.parentNode.removeChild(link)
                vm.$store.commit('removeDownload', file.id)
              })
            } else {
              vm.$store.commit('updatePendingDownload', response.data)
            }
          }).catch(() => {
            vm.$awn.alert('Failed to generate Zip, contact support for assistance.')
            vm.$store.commit('removeDownload', file.id)
          }).finally(() => {
            vm.pendingRequests = _.filter(vm.pendingRequests, function (item) {
              return item !== file.id
            })
          })
        }
      })
    }, 1000)
  },

  beforeDestroy () {
    window.clearInterval(this.intervalId)
    this.intervalId = null
  }

}
</script>



// WEBPACK FOOTER //
// src/components/Account/FileDownloadPoller.vue